import React from 'react';
import { connect } from 'react-redux';
import PromoCard from './PromoCard/PromoCard';
import PublicationSuggestions from './PublicationSuggestions';

const mapStateToProps = ({ session }) =>
  ({ isAuthenticated: session.isAuthenticated });

const SuggestionsPromoCard = ({ track }) => (
  <PromoCard
    title="Get free article suggestions today"
    description="Mendeley saves you time finding and organizing research"
    track={track}
  />
);

const Suggestions = ({ isAuthenticated, doc, track }) => {
  const tracking = {
    ...track,
    context: `${track.context || ''}Recommendations`
  };

  return isAuthenticated
    ? <PublicationSuggestions doc={doc} track={tracking} />
    : <SuggestionsPromoCard track={tracking} />;
};

export default connect(mapStateToProps, null)(Suggestions);



// WEBPACK FOOTER //
// ./src/universal/ui/components/Suggestions.js